import * as React from "react";

function SvgServicing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.812 12.665l12.872 12.84a3.056 3.056 0 01.205 4.105l-.697.85a3.075 3.075 0 01-4.547.226l-12.95-12.918H6.711c-.759 0-1.49-.28-2.054-.785l-3.224-2.895a3.059 3.059 0 01-1.016-2.276V9.134c0-.428.496-.666.83-.399l4.286 3.42h.687a2.05 2.05 0 001.447-.598l1.36-1.356c.383-.383.599-.902.599-1.444V5.998c0-.303-.135-.59-.368-.784L4.572 1.32a.51.51 0 01.327-.902h6.359c.91 0 1.775.403 2.358 1.101l4.196 5.023v6.124z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgServicing;
